var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.evaluationInProgress ? _c('div', {
    staticClass: "z-30 absolute inset-0 bg-indigo-600 bg-opacity-85 rounded-lg"
  }, [_c('div', {
    staticClass: "md:-my-2 py-0 md:py-20 sm:px-6 lg:px-24 h-full md:h-auto"
  }, [_c('div', {
    staticClass: "relative align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 table h-full"
  }, [_c('div', {
    staticClass: "m-5 md:m-15 2xl:m-20 mt-10 md:mt-20 2xl:mt-32 w-auto h-auto"
  }, [_c('h3', {
    staticClass: "mb-5 md:mb-10 2xl:mb-15"
  }, [_vm._v("\n          " + _vm._s(_vm.infosPage.libelle_template) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "text-lg text-gray-600 text-center mb-5 md:mb-10 2xl:mb-15"
  }, [_c('p', [_vm._v("Le modèle de page « " + _vm._s(_vm.infosPage.libelle_template) + " » n’est pas modifiable ou désactivable,")]), _vm._v(" "), _c('p', [_vm._v("car il existe au minimum une évaluation en cours.")]), _vm._v(" "), _c('p', [_vm._v("Veuillez clôturer les évaluations pour modifier cette page.")])]), _vm._v(" "), _c('span', {
    staticClass: "flex space-x-3 justify-center mb-5 md:mb-10 2xl:mb-15"
  }, [_vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_APERCU) ? _c('action-button', {
    staticClass: "h-full",
    attrs: {
      "border-color": "border-indigo-600",
      "text-color": "text-indigo-600",
      "bg-color": "bg-white",
      "bg-color-square": "bg-white",
      "icon-color": "text-pink-600",
      "libelle": "Visualiser le modèle",
      "icon": "eye"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.$emit('showPreview');
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_GESTION_DROITS_BENEFICIAIRE_MODELE_DE_PAGE) ? _c('action-button', {
    staticClass: "h-full",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-gray-900",
      "bg-color": "bg-teal-300",
      "bg-color-square": "bg-teal-100",
      "icon-color": "text-teal-600",
      "libelle": "Attribuer",
      "icon": "people"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.assignTemplate();
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('illustration', {
    staticClass: "inline-block",
    attrs: {
      "name": "notAllowed"
    }
  })], 1)])])])]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }